import { Document } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
export default function makeOnCopy(store) {
  return {
    onCopy: function onCopy(event, editor, next) {
      if (editor.value.selection.isCollapsed || !editor.isSelectionInTable()) {
        return next();
      }

      event.preventDefault();
      event.stopPropagation();
      var fragment = editor.value.fragment;
      var blocks = fragment.getBlocks();

      if (blocks.size === 1 && blocks.first().type === BlockTypes.TABLE_CELL) {
        fragment = Document.create({
          nodes: blocks.first().nodes
        });
      }

      editor.command('copyFragmentToClipboard', event, fragment);
    },
    onDocumentCopy: function onDocumentCopy(event, editor) {
      var tableId = store.getItem('lastFocusedTableId');
      if (!tableId) return; // No table selected

      event.preventDefault();
      event.stopPropagation();
      editor.command('copyFragmentToClipboard', event, editor.getFragmentFromTableSelection());
    }
  };
}